import ArticlePage from "components/ArticlePage/ArticlePage";
import useAuthGuard from "hooks/useAuthGuard";
import DefaultLayout from "layouts/default";
import FullPageLayout from "layouts/fullpage";
import React from "react";
import { useSelector } from "react-redux";
import {  Switch,   useLocation  } from "react-router-dom";
import BrandsRouter from "./Brands/BrandsRouter";
import ChangePassword from "./ChangePassword/ChangePassword";
import Contact from "./Contact/Contact";
import FormationQuizz from "./Formations/FormationQuizz/FormationQuizz";
import FormationRouter from "./Formations/FormationRouter";
import Homepage from "./Homepage/Homepage";
import News from "./Homepage/News/News";
import OneHrRouter from "./OneHr/OneHrRouter";
import Parrainage from "./Parrainage/Parrainage";
import ProfilRouter from "./Profil/ProfilRouter";
import SearchRouter from "./Search/SearchRouter";
import ShopRouter from "./Shop/ShopRouter";
import WallRouter from "./Wall/WallRouter";
import OneClick from "./OneClick/OneClick";
import { SentryRoute } from "index";

/**
 * Il y a encore du travail à faire, mais c'est une conversion de l'ancien AppRouter
 * en functional component qui est déjà beaucoup plus propre
 */
const DefaultSwitch = () => {
  const config = useSelector((state) => state.config);
  return (
    <section className="route-section">
      <div className="route-section-inner">
        <Switch>
          <SentryRoute exact path="/" component={Homepage} />
          <SentryRoute exact path="/search" component={SearchRouter} />
          {config.features.brands_enabled ? (
            <SentryRoute path="/brands" component={BrandsRouter} />
          ) : null}
          {config.features.learning_enabled ? (
            <SentryRoute path="/formations" component={FormationRouter} />
          ) : null}
          {config.features.social_wall_enabled ? (
            <SentryRoute path="/wall" component={WallRouter} />
          ) : null}
          {config.shopEnabled ? (
            <SentryRoute path="/shop" component={ShopRouter} />
          ) : null}
          <SentryRoute path="/profile" component={ProfilRouter} />
          <SentryRoute path="/oneHr" component={OneHrRouter} />
          <SentryRoute path="/contact" component={Contact} />
          <SentryRoute
            exact
            path="/articles/:brandId/:articleId"
            component={ArticlePage}
          />
          <SentryRoute exact path="/parrainage" component={Parrainage} />
          <SentryRoute exact path="/oneclick/:id" component={OneClick} />
          <SentryRoute exact path="/news/:id" component={News} />
          <SentryRoute component={Homepage} />
        </Switch>
      </div>
    </section>
  );
};

const FullPageSwitch = () => {
  const location = useLocation();

  return (
    <section className="route-section">
      <div className="route-section-inner">
        <Switch location={location}>
          <SentryRoute
            exact
            path="/change-password"
            component={ChangePassword}
          />
        </Switch>
      </div>
    </section>
  );
};

const AppSwitch = (props) => {
  useAuthGuard();

  // Don't load the switch at all if the user is not logged in
  // This prevents MANY errors
  const access_token = useSelector((state) => state.auth.access_token);

  if (!access_token) {
    return <></>;
  }

  return (
    <Switch>
      {/* Routes with no layout */}
      <SentryRoute
        exact
        path={`/formations/:id/:moduleId/scorm`}
        component={FormationQuizz}
      />

      {/* Full page layout */}
      <SentryRoute path={["/change-password"]} exact>
        <FullPageLayout>
          <FullPageSwitch />
        </FullPageLayout>
      </SentryRoute>

      {/* Default layout for all other routes */}
      <SentryRoute>
        <DefaultLayout>
          <DefaultSwitch />
        </DefaultLayout>
      </SentryRoute>
    </Switch>
  );
};

export default AppSwitch;
